const bulletinConfig = {
    dev: 'JN2n!jP5%RYjD5',
    test: 'MgXhWnxL92#zgq',
    stage: '7XaM%U3dkmTmD7',
    prod: '$H2%m$WvcCJPTM',
  };
  
  export default bulletinConfig;